import { render, staticRenderFns } from "./childList.vue?vue&type=template&id=d5133c52&scoped=true"
import script from "./childList.vue?vue&type=script&lang=js"
export * from "./childList.vue?vue&type=script&lang=js"
import style0 from "./childList.vue?vue&type=style&index=0&id=d5133c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5133c52",
  null
  
)

export default component.exports